import React, { useState, useEffect } from 'react';
import { Briefcase, Award, GraduationCap, MapPin } from 'lucide-react';
import Navbar from '../components/Layout/Navbar';
import Footer from '../components/Layout/Footer';
import MezunlarData from '../data/Mezunlar.json';

const AlumniPage = () => {
    const [alumni, setAlumni] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            // JSON verisini yükle
            const alumniData = MezunlarData.sort((a, b) => a.order - b.order);
            setAlumni(alumniData);
            setLoading(false);
        } catch (err) {
            setError('Mezun verileri yüklenirken bir hata oluştu.');
            console.error("Alumni data error:", err);
            setLoading(false);
        }
    }, []);

    const featuredAlumnus = alumni.length > 0 ? alumni[0] : null;
    const otherAlumni = alumni.length > 1 ? alumni.slice(1) : [];

    const ParallaxBackground = () => (
        <div 
            className="absolute top-0 left-0 w-full h-full bg-fixed"
            style={{
                backgroundImage: 'url(https://images.unsplash.com/photo-1554141316-1f748d1a14b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: -1,
            }}
        />
    );

    if (loading) {
        return <div className="min-h-screen bg-gray-900 flex items-center justify-center text-white">Yükleniyor...</div>;
    }

    if (error) {
        return <div className="min-h-screen bg-gray-900 flex items-center justify-center text-red-500">{error}</div>;
    }

    return (
        <div className="relative min-h-screen bg-gray-900 text-white">
            <ParallaxBackground />
            <div className="relative z-10 bg-black bg-opacity-50 backdrop-blur-sm">
                
                <header className="pt-24 pb-16 text-center">
                    <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight">Fakültemizin Gururları</h1>
                    <p className="mt-4 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
                        Hacettepe Fen Fakültesi'nden mezun olup bilim, teknoloji ve iş dünyasında iz bırakan öncülerimiz.
                    </p>
                </header>

                {featuredAlumnus && (
                    <section className="container mx-auto px-6 py-12">
                        <div className="bg-gray-800 bg-opacity-70 backdrop-blur-md rounded-2xl shadow-2xl lg:flex items-center">
                            <div className="lg:w-1/2">
                                <img
                                    className="w-full h-full object-cover rounded-t-2xl lg:rounded-l-2xl lg:rounded-t-none"
                                    src={featuredAlumnus.photo_url}
                                    alt={featuredAlumnus.name}
                                    onError={(e) => { e.target.onerror = null; e.target.src = `https://ui-avatars.com/api/?name=${featuredAlumnus.name.replace(' ', '+')}&background=0D8ABC&color=fff&size=512`; }}
                                />
                            </div>
                            <div className="lg:w-1/2 p-8 md:p-12">
                                <h2 className="text-4xl font-bold text-cyan-400">{featuredAlumnus.name}</h2>
                                <p className="mt-2 text-xl text-gray-300">Mezuniyet: {featuredAlumnus.graduation_year}</p>
                                
                                <div className="mt-6 space-y-4">
                                    <div className="flex items-center">
                                        <Briefcase className="w-6 h-6 text-cyan-400" />
                                        <p className="ml-3 text-lg">{featuredAlumnus.position}</p>
                                    </div>
                                    <div className="flex items-start">
                                        <Award className="w-6 h-6 text-cyan-400 mt-1" />
                                        <p className="ml-3 text-lg italic">"{featuredAlumnus.story}"</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}

                {otherAlumni.length > 0 && (
                     <section className="container mx-auto px-6 py-12">
                         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                             {otherAlumni.map(person => (
                                 <div key={person.id} className="bg-gray-800 bg-opacity-70 backdrop-blur-md p-6 rounded-xl shadow-lg transform hover:scale-105 transition-transform duration-300">
                                     <img 
                                        className="w-24 h-24 rounded-full mx-auto -mt-12 border-4 border-gray-700"
                                        src={person.photo_url}
                                        alt={person.name}
                                        onError={(e) => { e.target.onerror = null; e.target.src = `https://ui-avatars.com/api/?name=${person.name.replace(' ', '+')}&background=random&color=fff&size=128`; }}
                                     />
                                     <div className="text-center mt-4">
                                         <h3 className="text-xl font-semibold">{person.name}</h3>
                                         <p className="text-gray-400 text-sm">Mezuniyet: {person.graduation_year}</p>
                                         <p className="mt-2 text-sm text-cyan-400 flex items-center justify-center"><Briefcase size={14} className="mr-2" /> {person.position}</p>
                                         <p className="mt-3 text-gray-300 text-sm italic">"{person.story}"</p>
                                     </div>
                                 </div>
                             ))}
                         </div>
                     </section>
                )}

            </div>
        </div>
    );
};

export default AlumniPage; 